import Component from 'flarum/common/Component';
import SpeciesReferenceBox from './SpeciesReferenceBox';
/**
 * "Synonymes" box on the species page - every GBIF synonym of this species
 * (see SpeciesSynonymsService). Lives in the sidebar, right after
 * speciesClassificationBox's "Systématique" box (see SpeciesPage.js) - it
 * reuses that box's own look (a .ChampisSpeciesSearch-label header, a
 * bordered card, rows built from .SpeciesPage-referenceLink, see
 * SpeciesInfoBoxes.js/forum.less) rather than the blue
 * .ChampisDiscussionList-header + .ChampisDescriptionsList treatment its
 * main-column neighbors (Descriptions/Discussions/Clés) use, so it reads
 * as one more sidebar reference box rather than a stray main-column list
 * that ended up on the wrong side.
 *
 * champis.net shows this behind an "Afficher les synonymes" toggle -
 * deliberately not replicated here, since every other block on this page
 * is already just shown outright when non-empty rather than collapsed.
 * "Charger davantage" reveals more of the already-fetched list instead -
 * see SpeciesReferenceBox for the shared implementation (same
 * VISIBLE_STEP convention as DescriptionsPage.js/DeterminationKeysPage.js,
 * since a well-documented species can have 20+ synonyms).
 */
export default class SpeciesSynonymsBox extends Component {
  view(vnode) {
    return m(SpeciesReferenceBox, {
      gbifId: vnode.attrs.gbifId,
      endpoint: "species-synonyms",
      sectionClass: "SpeciesPage-synonyms",
      loadMoreClass: "SpeciesPage-synonymsLoadMore",
      headerKey: "champis-species.forum.species_page.synonyms_header"
    });
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesSynonymsBox', SpeciesSynonymsBox);